import { useDispatch, useSelector } from 'react-redux'
import { REDUX_STATUS_LOADING } from 'src/consumer/constants'
import { getTeacherProfileData } from 'src/reducers/teacherProfileData/services/teacherProfile'
import { selectTeacherProfileData } from 'src/reducers/teacherProfileData/teacherProfileDataReducer'

/**
 * Custom hook for managing mentor profile data
 * @param {Object} propMentorProfileData - Optional mentor data from props
 * @returns {Object} Mentor profile state and functions
 */
export const useMentorProfileData = (propMentorProfileData) => {
  const dispatch = useDispatch()

  const teacherProfileStoreData = useSelector(selectTeacherProfileData)
  const mentorProfileData = teacherProfileStoreData?.data
  const mentorProfileDataLoading = mentorProfileData?.status === REDUX_STATUS_LOADING
  // const [mentorProfileData, setMentorProfileData] = useState()
  // const [mentorProfileDataLoading, setMentorProfileDataLoading] = useState(false)

  /**
   * Fetch and set mentor profile data
   * @returns {Promise<Object>} Mentor profile data
   */
  // const getMentorProfileData = useCallback(async () => {
  //   if (propMentorProfileData) {
  //     setMentorProfileData(propMentorProfileData)
  //     return propMentorProfileData
  //   }

  //   setMentorProfileDataLoading(true)
  //   try {
  //     const data = await getMentorProfile(propMentorProfileData)
  //     setMentorProfileData(data)
  //     return data
  //   } catch (error) {
  //     console.error('Error fetching mentor profile:', error)
  //     return null
  //   } finally {
  //     setMentorProfileDataLoading(false)
  //   }
  // }, [propMentorProfileData])

  // /**
  //  * Refresh mentor profile data (force fetch from API)
  //  * @returns {Promise<Object>} Fresh mentor profile data
  //  */
  // const refreshMentorProfile = useCallback(async () => {
  //   setMentorProfileDataLoading(true)
  //   try {
  //     const data = await getMentorProfile(null) // Force API call
  //     setMentorProfileData(data)
  //     return data
  //   } catch (error) {
  //     console.error('Error refreshing mentor profile:', error)
  //     return null
  //   } finally {
  //     setMentorProfileDataLoading(false)
  //   }
  // }, [])

  return {
    mentorProfileData,
    mentorProfileDataLoading,
    refreshMentorProfile: async () => {
      if (propMentorProfileData) {
        return propMentorProfileData
      }
      const action = await dispatch(getTeacherProfileData())
      if (action?.type?.endsWith('/fulfilled')) {
        return action?.payload || null
      }
      return mentorProfileData || null
    },
  }
}

export default useMentorProfileData
